<script setup lang="ts">
import { Button } from "@/components/ui/button"
import { CircleUser } from "lucide-vue-next"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu"
import { inject, onMounted, ref } from "vue"
import { getCsrfToken, getMetaContent } from "@/lib/utils"
import { doLogin } from "@/lib/router_utils.ts"
import { CurrentUser } from "@/lib/user.ts"

const logoutForm = ref<HTMLFormElement | null>(null)
const csrfToken = ref<string | null>(null)
const signOutPath = ref<string>("")

const signOut = (): void => {
  logoutForm.value?.submit()
}

const currentUser = inject("currentUser") as CurrentUser

onMounted(() => {
  csrfToken.value = getCsrfToken()
  signOutPath.value = getMetaContent("sign-out-path") || ""
})
</script>

<template>
  <Button
    v-if="!currentUser.user"
    @click="doLogin()"
    variant="outline"
  >
    {{ $t("commons.login") }}
  </Button>

  <form ref="logoutForm" :action="signOutPath" method="post" style="display: none">
    <input type="hidden" name="_method" value="delete" />
    <input type="hidden" name="authenticity_token" :value="csrfToken" />
  </form>

  <DropdownMenu v-if="currentUser.user">
    <DropdownMenuTrigger as-child>
      <Button variant="secondary" size="icon" class="rounded-full">
        <CircleUser class="h-5 w-5" />
        <span class="sr-only">Toggle user menu</span>
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end">
      <DropdownMenuLabel>{{ currentUser.user.description }}</DropdownMenuLabel>

      <DropdownMenuLabel class="font-normal text-xs" v-if="currentUser.user.convention">
        {{ currentUser.user.convention?.name }}
      </DropdownMenuLabel>

      <DropdownMenuSeparator />

      <DropdownMenuItem class="cursor-pointer" @click="signOut">Logout</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>


